<template>
    <div v-loading="loading" class="card" v-for="(item, index) in displayedList" :key="index">
        <div class="content" @click="goToDetail(item)">
            <div class="image-container">
                <img class="image" :src="item.contentImg[0]" alt="">
            </div>
            <div class="title">{{ item.contentTitle }}</div>
            <div class="tips-container">
                <span class="tips" v-for="(tag, tagIndex) in item.tips" :key="tagIndex">{{ tag }}</span>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { ref, onMounted, defineProps, computed } from 'vue';
import { useStore } from '@/store/index';
const store = useStore();
const router = useRouter();

const props = defineProps({
    categoryId: {
        type: String,
        required: true,
    },
    isShow: {
        type: Boolean,
        required: true,
    }
});

const list = ref([]);
const tags = ref([]);
const loading = ref(false)

// 计算属性，根据 isShow 的值返回相应的 list
const displayedList = computed(() => {
    return props.isShow ? list.value : list.value.slice(0, 8);
});

onMounted(() => {
    getInfo();
});

const getInfo = async () => {
    loading.value = true
    loading.value = true
    const _projectCaseData = store.allData['/projectCase']
    list.value = _projectCaseData?.filter(v => v.contentType !== 'banner');
    await getTags(); // 获取标签
    loading.value = false
};

const getTags = async () => {
    tags.value = store.allTag
    // 将标签添加到内容中
    list.value.forEach(item => {
        const matchedLabels = tags.value
            .filter(tag => item.contentTags.includes(tag.dictValue))
            .map(tag => tag.dictLabel);
        item.tips = matchedLabels;
    });
};

const goToDetail = (item) => {
    router.push({
        path: '/caseDetail',
        query: { currentId: item.id, categoryId: props.categoryId }
    });
};
</script>

<style scoped lang="less">
.card {
    width: calc(100% / 4 - calc(16 * var(--groot-ui-rpx)));
    margin: 0 calc(8 * var(--groot-ui-rpx)) calc(20 * var(--groot-ui-rpx));
    border-radius: calc(4 * var(--groot-ui-rpx));
    overflow: hidden;
    box-shadow: 0 calc(2 * var(--groot-ui-rpx)) calc(10 * var(--groot-ui-rpx)) rgba(0, 0, 0, 0.11);
    cursor: pointer;
    background-color: #FFF;
    transition: all 0.5s;
}

.content {
    padding: calc(20 * var(--groot-ui-rpx));
}

.title {
    margin: calc(24 * var(--groot-ui-rpx)) 0 calc(8 * var(--groot-ui-rpx));
    color: #333;
    font-weight: bold;
    font-size: calc(20 * var(--groot-ui-rpx));
    position: relative;
    text-align: left;

    &:after {
        content: "";
        width: calc(4 * var(--groot-ui-rpx));
        height: calc(20 * var(--groot-ui-rpx));
        position: absolute;
        top: 50%;
        margin-top: calc(-10 * var(--groot-ui-rpx));
        left: calc(-16 * var(--groot-ui-rpx));
        background-color: #126324;
    }
}

.tips-container {
    display: flex;
    margin-bottom: calc(14 * var(--groot-ui-rpx));
    flex-wrap: wrap;
}

.tips {
    padding: calc(3 * var(--groot-ui-rpx)) calc(2 * var(--groot-ui-rpx));
    margin-top: calc(6 * var(--groot-ui-rpx));
    margin-right: calc(3 * var(--groot-ui-rpx));
    font-size: calc(12 * var(--groot-ui-rpx));
    color: #126324;
}

.card:hover .title {
    color: #126324;
}

.image-container {
    width: 100%;
    overflow: hidden;
    height: calc(176 * var(--groot-ui-rpx));
    border-radius: calc(4 * var(--groot-ui-rpx));
}

.image {
    width: 100%;
    height: calc(176 * var(--groot-ui-rpx)) !important;
    transition: transform 0.5s;
    object-fit: cover;
}

.card:hover .image {
    transform: scale(1.1);
}
</style>
